import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUpdateData } from "./types";

const chatSlice = createSlice({
    name: 'dashboard',
    initialState: {
        updateData: ({} as any) as IUpdateData,
    },
    reducers: {
        refreshData: (state, action: PayloadAction<IUpdateData>) => {
            state.updateData = action.payload
        },
        dashboardWSConnecting: (state) => {
            return;
        },
        dashboardWSDisconnecting: (state) => {
            return;
        },
    },
});

export const {
    refreshData,
    dashboardWSConnecting,
    dashboardWSDisconnecting
} = chatSlice.actions
export default chatSlice.reducer

